module.exports = __webpack_public_path__ + "assets/img/title-e92b55e1.png";